import * as Yup from "yup";
import { createFields } from "../helpers/createFields.js";
import { toBoolean } from "../helpers/toBoolean.js";
const fields = createFields({
  occupation: {
    __type: "text",
    label: "field.occupation",
    name: "occupation",
    optional: true,
    helperText: "field.occupation_helper",
    inputProps: {
      type: "text"
    },
    validation: Yup.string()
  },
  isPregnant: {
    __type: "radioGroup",
    label: "field.are_you_pregnant",
    name: "isPregnant",
    helperText: "field.is_pregnant_helper",
    isRequired: true,
    options: [
      {
        label: "yes",
        value: "true"
      },
      {
        label: "no",
        value: "false"
      }
    ],
    inputProps: {
      withText: true
    },
    validation: Yup.boolean().when(
      "gender",
      (gender) => gender === "MALE" ? Yup.boolean() : Yup.boolean().required()
    ),
    visibleWhen: ({ gender }) => gender !== "MALE",
    hooks: {
      beforeChange: (value, { setFieldValue }, _event) => {
        if (!toBoolean(value)) {
          setFieldValue("pregnantMonths", void 0);
        }
      }
    }
  },
  pregnantMonths: {
    __type: "select",
    label: "field.pregnant_month",
    name: "pregnantMonths",
    isRequired: true,
    inputProps: {
      type: "number"
    },
    options: Array.from({ length: 9 }).map((_, index) => ({ value: String(index + 1), label: String(index + 1) })),
    validation: Yup.number().min(0).max(9).when("isPregnant", {
      is: true,
      then: Yup.number().required("field.pregnant_months_error"),
      otherwise: Yup.number()
    }),
    visibleWhen: ({ isPregnant }) => {
      return toBoolean(isPregnant);
    }
  },
  isSmoker: {
    __type: "toggle",
    label: "field.is_smoker",
    name: "isSmoker",
    helperText: "field.is_smoker_helper",
    inputProps: {
      withText: true
    },
    validation: Yup.boolean(),
    hooks: {
      beforeChange: (value, { setFieldValue }, _event) => {
        if (!toBoolean(value)) {
          setFieldValue("cigarettesPerDay", void 0);
        }
      }
    }
  },
  cigarretesPerDay: {
    __type: "text",
    label: "field.how_many_cigarretes",
    name: "cigarettesPerDay",
    isRequired: true,
    inputProps: {
      type: "number"
    },
    validation: Yup.number().when("isSmoker", {
      is: true,
      then: Yup.number().min(1).max(1e3, "field.cigarettes_per_day_exceeded_error").required("field.cigarettes_per_day_error"),
      otherwise: Yup.number()
    }),
    visibleWhen: ({ isSmoker }) => toBoolean(isSmoker)
  },
  consumesAlcohol: {
    __type: "toggle",
    label: "field.consumes_alcohol",
    name: "consumesAlcohol",
    validation: Yup.boolean(),
    helperText: "field.consumes_alcohol_helper",
    inputProps: {
      withText: true
    }
  },
  consumesDrugs: {
    __type: "toggle",
    label: "field.consumes_drugs",
    name: "consumesDrugs",
    validation: Yup.boolean(),
    helperText: "field.consumes_drugs_helper",
    inputProps: {
      withText: true
    }
  },
  weightOver120Kg: {
    __type: "toggle",
    label: "field.weight_over_120_kg",
    name: "weightOver120Kg",
    validation: Yup.boolean(),
    helperText: "field.weight_over_120_kg_helper"
  },
  heightOver2M: {
    __type: "toggle",
    label: "field.height_over_2m",
    name: "heightOver2M",
    validation: Yup.boolean(),
    helperText: "field.height_over_2m_helper"
  }
});
const buildSchema = (fs) => {
  return Object.fromEntries(
    Object.values(fs).map((settings) => [settings.name, settings.validation]).filter(([_, validation]) => Boolean(validation))
  );
};
const validationSchema = Yup.object().shape(buildSchema(fields));
export {
  fields as default,
  validationSchema
};
